export class ErrorReporter {
	public static readonly instance = new ErrorReporter();

	private readonly rollbar: Rollbar | null = null;

	private constructor() {
		const rollbarConfig = {
			accessToken: 'a61a117e92374a5cae715c6e33413af6',
			captureUncaught: false,
			captureUnhandledRejections: false,
			payload: {
				environment: CONFIG.STAGE,
			},
		};

		this.rollbar = window && window['rollbar'] ? new window['rollbar'](rollbarConfig) : null;
	}

	public report(error: unknown): void {
		if (this.rollbar === null) return;

		if (CONFIG.STAGE === 'prd') {
			this.rollbar.error(error);
		}

		throw error;
	}
}
